export const parseApiErrors = (error) => {
    if (!error.response || !error.response.data) {
        return "An unknown error occurred. Please try again.";
    }

    const { data } = error.response;
    if (typeof data.detail === 'string') {
        return data.detail;
    }

    if (Array.isArray(data.detail)) {
        return data.detail
            .filter(e => e.loc && (e.loc.includes("email") ||e.loc.some(loc => loc.includes("password"))))
            .map(e => {
                let message = e.msg;

                // If type is value_error, strip "Value error, " from the message
                if (e.type === "value_error" && message.startsWith("Value error, ")) {
                    message = message.replace("Value error, ", "");
                }

                // Return the message with any available context reason or just the message
                return e.ctx?.reason || message;
            })
            .join('. ') || "An error occurred. Please check your input";
    }

    if (typeof data.detail === 'object' && data.detail !== null) {
        if (data.detail.error) {
            return data.detail.error;
        }
    }

    return "An error occurred. Please check your input.";
}